export default "__VITE_ASSET__DaLmR_QY__";